module.exports = __webpack_public_path__ + "img/icon-done.f30af00b.png";